

import React, { lazy, Suspense } from "react";
import {  Route, Routes } from "react-router-dom";
import { Path } from "./routes";
//import ProtectedRoute from "../store/ProtectedRoute";
 

const NotFound = lazy(() => import("../pages/404"));
const Facilitator = lazy(() => import("../pages/facilitator"));
const Home = lazy(() => import("../pages/home"));
//const ContactUs = lazy(() => import("../pages/contact"));
const Login = lazy(() => import("../pages/login"));

const UserDashboard = lazy(() => import("../pages/user/user"));
const AdminDashboard = lazy(() => import("../pages/admin/admin"));





const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Facilitator} element={<Facilitator />} />
         <Route path={Path.Home} element={<Home />} />
        {/* <Route path={Path.ContactUs} element={<ContactUs />} /> */}
         <Route path={Path.Login} element={<Login />} />

           <Route path={Path.UserDashboard} element={<UserDashboard />} />
            <Route path={Path.AdminDashboard} element={<AdminDashboard />} />
       
        


        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;